<div class="row">
	<div class="col-md-2"></div>
		<div class="col-md-8">
			<video width="100%" height="auto" controls autoplay>
			  <source src="/assets/videos/what_controls_sleep.mp4" type="video/mp4">
			Your browser does not support the video tag.
			</video>
		</div>
	<div class="col-md-2"></div>

	<div class="col-md-2"></div>
		<div class="col-md-8">
			<p class="ion-text-left" style="color : #002E46 !important;">
				One of the keys to understanding how you can improve your sleep is to understand how your brain controls sleep.
				Sleep is regulated by two internal biological mechanisms. These two systems work together to regulate when you wake
				up and when you fall sleep.
			</p>
			<br>

			<mat-accordion class="example-headers-align" multi="false">
				<mat-expansion-panel class="ion-text-left">

					<mat-expansion-panel-header>

						<mat-panel-title style="font-weight: bold; color : #002E46 !important;">

							HOMEOSTASIS


						</mat-panel-title>

					</mat-expansion-panel-header>
					<p style="color : #002E46 !important;">
						The first way that your brain controls sleep is by measuring how long you’ve been awake. This is
						called <STRONG>Homeostasis</STRONG>. Quite simply, <strong> the longer you’ve been
							awake,
							the higher your sleep drive builds up.</strong>


					</p>
					<br>
					<p style="color : #002E46 !important;">

						Think of it this way: Your “Sleep Pressure” builds up during the day, and the longer you’ve been awake, the
						more “sleep pressure” builds up. That same sleep drive, or pressure, decreases quickly during the time
						you’re asleep.

					</p>


					<br>
					<p style="color : #002E46 !important;">

						Let’s try to understand this concept by using an example of a rubber band. The more the person stretches the
						rubber band, the more rebound force, or pressure, the band builds up. So the further the rubber band is
						stretched when you release it, the stronger the reaction trying to return the rubber band to its normal
						length will be.
					</p>
					<img src="http://tranqsleep.com/wp-content/uploads/2021/09/311.jpg" style="width: 100%; height : auto;">
					<img src="http://tranqsleep.com/wp-content/uploads/2021/09/31.jpg" style="width: 100%; height : auto;">

					<br>
					<p style="color : #002E46 !important;">
						In the case of sleep, the longer you stay awake, the higher the pressure for sleep.
					</p>


				</mat-expansion-panel>

				<!---->
				<mat-expansion-panel class="ion-text-left">

					<mat-expansion-panel-header>
						<mat-panel-title style="font-weight: bold; color : #002E46 !important;">
							CIRCADIAN PROCESS
						</mat-panel-title>

					</mat-expansion-panel-header>
					<p style="color : #002E46 !important;">
						The second thing that controls our sleep is the inner biological clock, which is medically referred to as
						the <strong> Circadian Process.</strong>


					</p>
					<br>
					<p style="color : #002E46 !important;">
						Deep within our brain we have a biological clock that controls our sleep. This clock increases our sleep
						drive in the middle of the night and has its lowest drive during the day.
					</p>


					<br>
					<p style="color : #002E46 !important;">
						If you've ever had to stay awake all night, you’ll know that this makes sense. The times that it is hardest
						to stay awake is from about 3 am to 6 am.
					</p>

					<br>
					<p style="color : #002E46 !important;">
						The Circadian process controls your timing of sleep, causing you to feel sleepy at night and triggering your
						tendency to wake up in the morning without an alarm. Your body’s biological clock, which is based on a
						roughly 24-hour day, is generally synchronized with environmental cues such as light and temperature, but it
						can continue to function even in the absence of any external cues.
					</p>


					<p style="color : #002E46 !important;">
						Here is an illustration on how both processes work together to regulate our sleep:
					</p>


					<img src="http://tranqsleep.com/wp-content/uploads/2021/09/32.jpg" style="width: 100%; height : auto;">

					<br>
					<p style="color : #002E46 !important;">
						At the end of the day, our “sleep pressure” is high because of how long we’ve been awake which allow us to
						fall asleep. Later in the night, our biological clock’s sleep drive reaches a peak, helping us to stay
						asleep.
					</p>

					<br>
					<p style="color : #002E46 !important;">
						Therefore, we can imagine that anything externally or internally affecting these 2 processes will have an
						effect on our sleep/wake cycle. Things like exposure to electronic devices, strenuous exercise prior to
						going to bed, consumption of caffeinated beverage late in the day, or medications that changes our sleep
						architecture or medical conditions - they all affect our sleep cycle, preventing us from falling or staying
						asleep.
					</p>
					<mat-card style="background-color: #e9f3f1;">
						<mat-card-content>
							<mat-card-header>
								<mat-card-title style="font-weight: bold;" class="ion-text-center">Key Points</mat-card-title>

							</mat-card-header>


							<p style="color : #002E46 !important;">
								<strong>Homeostasis Process: </strong>
								The longer we stay awake, the stronger the sleep pressure will be.
							</p>
							<br>

							<p style="color : #002E46 !important;">
								<strong> Circadian Process:</strong>
								The internal clock that regulates our sleep/wake cycles.
							</p>
							<br>
							<p style="color : #002E46 !important;">
								<strong> Anything externally or internally can affect these 2 processes. </strong>

							</p>

							<br>


						</mat-card-content>
					</mat-card>

				</mat-expansion-panel>
				<!---->
			</mat-accordion>
		</div>
	<div class="col-md-2"></div>
</div>


